<template src="./TicketDetailDialog.html"></template>

<script>
import { getTicket, updateTicket, deleteTicket, addTicketAttachment, deleteTicketAttachment, uploadFile, deleteFileFirebase } from '../../services'
import { ticketStatusVal } from '../../utils/constants'
import { formatDate, getTicketPriority, getTicketPriorityColor } from '../../utils/computeds'
import { formatDueDate } from '../../utils/dueDate'
import TicketFormDialog from './TicketFormDialog.vue'
import TicketComments from './TicketComments.vue'
import TicketStatusHistory from './TicketStatusHistory.vue'

export default {
  name: 'TicketDetailDialog',
  components: { TicketFormDialog, TicketComments, TicketStatusHistory },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: String,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    ticket: null,
    loading: false,
    editOpen: false,
    tab: 0,
    statusOptions: ticketStatusVal
  }),
  computed: {
    formatDate,
    getTicketPriority,
    getTicketPriorityColor,
    assigneeNames () {
      const assignees = this.ticket?.assignees || (this.ticket?.assignedTo ? [this.ticket.assignedTo] : [])
      return assignees.length
        ? assignees.map((assignee) => `${assignee.name} ${assignee.lastName || ''}`.trim()).join(', ')
        : 'Sin asignar'
    }
  },
  watch: {
    value (isOpen) {
      if (isOpen && this.ticketId) { this.fetchTicket() }
    }
  },
  methods: {
    formatDueDate,
    async fetchTicket () {
      this.loading = true
      try {
        this.ticket = await getTicket(this.ticketId)
      } catch (err) {
        console.error('Error fetching ticket detail:', err)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.$emit('update', false)
    },
    async onStatusChange (status) {
      try {
        await updateTicket(this.ticket.id, { status })
        await this.fetchTicket()
        this.$emit('changed')
      } catch (err) {
        console.error('Error updating ticket status:', err)
      }
    },
    onSaved () {
      this.fetchTicket()
      this.$emit('changed')
    },
    async addAttachments (event) {
      const files = Array.from(event.target.files || [])
      event.target.value = ''
      if (!files.length) return
      try {
        await Promise.all(files.map(async (file, index) => {
          const fileName = `${new Date().getTime()}-${index}-${file.name}`
          const url = await uploadFile('tickets', fileName, file)
          await addTicketAttachment(this.ticket.id, { name: file.name, url })
        }))
        await this.fetchTicket()
      } catch (err) {
        console.error('Error adding ticket attachment:', err)
        this.$swal({ text: 'Ocurrió un error al subir el adjunto.', buttons: false, icon: 'error', timer: 3000 })
      }
    },
    async removeAttachment (attachment) {
      try {
        await Promise.all([
          deleteFileFirebase(attachment.url),
          deleteTicketAttachment(this.ticket.id, attachment.id)
        ])
        await this.fetchTicket()
      } catch (err) {
        console.error('Error deleting ticket attachment:', err)
      }
    },
    confirmDelete () {
      this.$swal({
        title: '¿Está seguro de eliminar el ticket?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) { this.removeTicket() }
      })
    },
    async removeTicket () {
      try {
        await deleteTicket(this.ticket.id)
        this.$swal({ text: 'Ticket eliminado.', buttons: false, icon: 'success', timer: 2500 })
        this.$emit('changed')
        this.close()
      } catch (err) {
        console.error('Error deleting ticket:', err)
        this.$swal({
          text: err.message ?? 'Ocurrió un error, intenta más tarde.', buttons: false, icon: 'error', timer: 3000
        })
      }
    }
  }
}
</script>

<style lang="scss" src="./TicketDetailDialog.scss" scoped></style>
